/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type GetStakeableDataByIdQueryVariables = Types.Exact<{
	filter?: Types.InputMaybe<Types.AssetConfigFilter>;
}>;

export type GetStakeableDataByIdQuery = {
	__typename?: "Query";
	assetConfig: {
		__typename?: "AssetConfigResponse";
		assets?: Array<{
			__typename?: "StakeableAsset";
			assetId: string;
			stakingMode: Types.StakingMode;
			availability: string;
			yearlyInterest: number;
			rewardIntervalInDays: number;
			stakingType: Types.StakingType;
			unboundPeriod?: number | null;
			isAutoStakingEnabled: boolean;
			minStakingAmount: { __typename?: "CurrencyAmount"; value: string };
			nextReward: { __typename?: "DateTime"; iso8601: string; unixTimestamp: number };
		}> | null;
	};
	balances: Array<{
		__typename?: "StakingBalance";
		asset: { __typename?: "StakeableAsset"; assetId: string };
		stakedAmount: { __typename?: "CurrencyAmount"; value: string };
		rewardsAmount: {
			__typename?: "RewardsAmount";
			totalCurrent: {
				__typename?: "Balance";
				asset: { __typename?: "CurrencyAmount"; value: string };
				fiat: { __typename?: "FiatAmount"; value: string };
			};
			totalLastMonth: {
				__typename?: "Balance";
				asset: { __typename?: "CurrencyAmount"; value: string };
				fiat: { __typename?: "FiatAmount"; value: string };
			};
		};
	}>;
};

export const GetStakeableDataByIdDocument = gql`
	query getStakeableDataById($filter: AssetConfigFilter) {
		assetConfig(filter: $filter) {
			assets {
				assetId
				stakingMode
				availability
				yearlyInterest
				minStakingAmount {
					value
				}
				nextReward {
					iso8601
					unixTimestamp
				}
				rewardIntervalInDays
				stakingType
				unboundPeriod
				isAutoStakingEnabled
			}
		}
		balances {
			asset {
				assetId
			}
			stakedAmount {
				value
			}
			rewardsAmount {
				totalCurrent {
					asset {
						value
					}
					fiat {
						value
					}
				}
				totalLastMonth {
					asset {
						value
					}
					fiat {
						value
					}
				}
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class GetStakeableDataByIdGQLService extends Apollo.Query<
	GetStakeableDataByIdQuery,
	GetStakeableDataByIdQueryVariables
> {
	document = GetStakeableDataByIdDocument;
	client = "staking";
	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
